import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import TransactionCard from './Card'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { propertyTransactions } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => {
		return ({
			propertyTransactions: propertyTransactions(state, props.propertyID)
		})
	}
)

export class TransactionList extends Component {
	render() {
		let { props } = this
	    return(
			<List
				style={{
					backgroundColor: "transparent"
					, paddingTop: "0"
				}}
			>
				{(R.keys(props.propertyTransactions).length)?
					R.map(transaction => <TransactionCard transactionId={transaction._id} />, R.reverse(props.propertyTransactions))
					: <p style={{margin:"20px 0 20px 20pt", color: "#A0A0A0"}}>No transactions</p>
				}
			</List>
	    )
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions]))(TransactionList)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/transactions/List.js